import React, { useEffect } from 'react'

export const OTPStep = (props: any) => {
   const { reset, currentSep } = props

   useEffect(() => {
      reset()
   }, [currentSep])

   return <>{props.children}</>
}
